import { FC } from "react";
import svgIcons from "../assets/svg/svgIcons";

type TooptipInfoButtonProps = {
  buttonClass?: string;
  text: string;
};

const TooptipInfoButton: FC<TooptipInfoButtonProps> = ({
  buttonClass = "px-2.5 rounded-lg bg-gray-200 hover:bg-gray-300 focus:bg-gray-300",
  text,
}) => {
  return (
    <button type="button" className={buttonClass} title={text}>
      <img
        // className="ml-2 transition-all group-focus:grayscale-0 group-focus:brightness-0 group-focus:invert group-hover:grayscale-0 group-hover:brightness-0 group-hover:invert"
        src={svgIcons.Info}
        alt={text}
      />
    </button>
  );
};
export default TooptipInfoButton;
